<template>
	<tr>
		<td class='fill-height'>
			<v-sheet :color='useColor ? "primary" : ""' :dark='useColor' :width='headerWidth' class='header-cell'>
				<span class='display-1 font-weight-light text-uppercase pa-3' style='opacity: 0.8' v-text='title' />
			</v-sheet>
		</td>
		<td>
			<v-card class='opaqueBg ma-0'>
				<v-card-text>
					{{text}}
					<slot></slot>
				</v-card-text>
			</v-card>
		</td>
	</tr>
</template>

<script>
export default {
	name: 'SectionContainer',
	props: {
		title: String,
		text: String,
		headerWidth: {
			type: String,
			default: '260px',
		},
		useColor: {
			type: Boolean,
			default: true,
		},
	},
}
</script>

<style lang="sass" scoped>
.t-row
	display: table-row
	outline: 1px solid red

.t-cell
	display: table-cell
	outline: 1px solid blue

.header-cell
	background: linear-gradient(180deg, rgba(0,56,122,0) 50%, rgba(255,255,255,0.5) 100%)
	height: 100%
</style>